import { rootApi } from "../../api/rootApi";

export const employeeApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllEmployee: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/employee`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    uploadEmployeeCsv: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/employee/upload-csv`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    upateEmployeeStatus: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/employee/status`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    upateEmployee: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/employee/edit`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    transferEmployee: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/employee/account-transfer`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    uploadEmpCityCsv: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/employee/city/upload-csv`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    fetchEmpCity: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/employee/city`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    syncEmployee: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/employee/sync`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: {
            type: params.type
          },
        };
      },
    }),
    syncLeftEmployee: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/employee/sync-left`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: {
            type: params.type
          },
        };
      },
    }),
    employeeCsv: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/employee/employee-csv`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          }
        };
      },
    }),
    employeeCityMapCsv: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/employee/emp-city-csv`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          }
        };
      },
    })
  })
});

export const {
  useFetchAllEmployeeMutation,
  useUploadEmployeeCsvMutation,
  useUpateEmployeeStatusMutation,
  useTransferEmployeeMutation,
  useUpateEmployeeMutation,
  useUploadEmpCityCsvMutation,
  useFetchEmpCityMutation,
  useSyncEmployeeMutation,
  useSyncLeftEmployeeMutation,
  useEmployeeCsvMutation,
  useEmployeeCityMapCsvMutation
} = employeeApi;
